const config = {
  stage: "prod",
  dev: {
    appRegistration: {
      clientId: "a6cbbcf3-b384-4d3f-897a-de2b1ec8852f",
      tenantId: "8e61d5fe-7749-4e76-88ee-6d8799ae8143",
      redirectUri: "https://poletop-dev.dteco.com",
      logoutUrl: "https://poletop-dev.dteco.com"
    },
    staticWebsite: {
      url: "https://poletop-dev.dteco.com"
    },
    appService: {
      baseUrl: "https://poletop-dev.dteco.com",
      hostKey: "jToZ0b4lCsqXZ9eTd6Fa4vpYC1yPFWffvyZQqCU1NCQMAzFubOG-hg=="
    }
  },
  test: {
    appRegistration: {
      clientId: "a6cbbcf3-b384-4d3f-897a-de2b1ec8852f",
      tenantId: "8e61d5fe-7749-4e76-88ee-6d8799ae8143",
      redirectUri: "https://poletop-test.sites.dteenergy.com",
      logoutUrl: "https://poletop-test.sites.dteenergy.com"
    },
    staticWebsite: {
      url: "https://poletop-test.sites.dteenergy.com"
    },
    appService: {
      baseUrl: "https://poletop-test.sites.dteenergy.com",
      hostKey: "jToZ0b4lCsqXZ9eTd6Fa4vpYC1yPFWffvyZQqCU1NCQMAzFubOG-hg=="
    }
  },
  prod: {
    appRegistration: {
      clientId: "a6cbbcf3-b384-4d3f-897a-de2b1ec8852f",
      tenantId: "8e61d5fe-7749-4e76-88ee-6d8799ae8143",
      redirectUri: "https://poletop.dteenergy.com",
      logoutUrl: "https://poletop.dteenergy.com"
    },
    staticWebsite: {
      url: "https://poletop.dteenergy.com"
    },
    appService: {
      baseUrl: "https://poletop.dteenergy.com",
      hostKey: "jToZ0b4lCsqXZ9eTd6Fa4vpYC1yPFWffvyZQqCU1NCQMAzFubOG-hg=="
    }
  }
};

export { config };
